import { FormattedMessage, useIntl } from "react-intl";

import { token } from "@atlaskit/tokens";

import { DEFAULT_VALUES } from "@/libraries/web-framework";
import {
    EnhancedBannerAlert,
    EnhancedBannerProps
} from "@/patterns/adg4/enhanced-banner-alert/enhanced-banner-alert";
import { experiments, useExperiment } from "@/utils/experiment";

export const Team25LiftedBanner = (props: {
    testGwp5090BannerExperiment?: boolean;
}) => {
    const { testGwp5090BannerExperiment } = props;

    const intl = useIntl();
    const gwp5090BannerExperiment = useExperiment(
        experiments.gwp5090ExperimentBannerJSM
    );

    const gwp5090IsLiftedBanner =
        testGwp5090BannerExperiment ||
        (gwp5090BannerExperiment != undefined &&
            gwp5090BannerExperiment.type === "enrolled" &&
            gwp5090BannerExperiment.value === "lifted");

    const gwp5090Team25Config: EnhancedBannerProps = {
        identifier: "GWP5090.jsm-product-tour.lifted",
        bannerType: "lifted",
        customCSS: { marginBottom: token("space.600") },
        text: (
            <>
                <FormattedMessage
                    id="team25-banners-and-butterbars.jsm.text"
                    defaultMessage="<strong>April 8-10 • Anaheim, California</strong>Be the first to demo our latest AI innovations and deliver game-changing experiences at Team &rsquo;25!"
                    values={DEFAULT_VALUES}
                />
            </>
        ),
        mobileText: (
            <>
                <FormattedMessage
                    id="team25-banners-and-butterbars.jsm.mobile-text"
                    defaultMessage="<strong>April 8-10 • Anaheim, California</strong>Demo our latest AI tools at Team &rsquo;25!"
                    values={DEFAULT_VALUES}
                />
            </>
        ),
        productKey: "home",
        backgroundPreset: "gwp-5090-banners",
        imageProps: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/gf1wkse40oux4nf58b103kknvb18p4yc.webp",
            alt: "Team25", //Event name is not localized
            width: 200
        },
        linkText: "Get your pass",
        linkUrl:
            "https://events.atlassian.com/team?utm_medium=event-web-referral&utm_source=jsm_product-tour&event_context=701QB00000Lg6oBYAR&utm_campaign=K:event|H:any|N:Team_25|P:agnostic|O:event-marketing|F:pre-event|C:event-home&utm_content=lifted-bar_WEBTEAM-17396&event_id=216653",
        dataEventProps: {
            "data-product-key": "home",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": intl.formatMessage({
                id: "team25-banners-and-butterbars.jsm.cta",
                defaultMessage: "Get your pass"
            }),
            "data-label-english": "Get your pass"
        }
    };

    if (gwp5090IsLiftedBanner) {
        return <EnhancedBannerAlert {...gwp5090Team25Config} />;
    }
    return null;
};
